import { render, staticRenderFns } from "./ServiceRequestList.vue?vue&type=template&id=0b7f9984&"
import script from "./ServiceRequestList.vue?vue&type=script&lang=js&"
export * from "./ServiceRequestList.vue?vue&type=script&lang=js&"
import style0 from "./ServiceRequestList.vue?vue&type=style&index=0&id=0b7f9984&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports